import { AlertCircle, RefreshCw, Wifi } from "lucide-react";

function StreamingUnavailable() {
  return (
    <div className="min-h-[calc(100vh-70px)] bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="max-w-xl w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Icon Container */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-red-500 rounded-full opacity-20 animate-ping"></div>
              <div className="relative bg-red-100 p-4 rounded-full">
                <AlertCircle className="w-12 h-12 text-red-600" />
              </div>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
            Streaming Unavailable
          </h1>

          {/* Description */}
          <p className="text-slate-600 mb-6 leading-relaxed">
            Message streaming is currently not available. This feature allows
            real-time message delivery and updates.
          </p>

          {/* Status Indicators */}
          <div className="bg-slate-50 rounded-xl p-4 mb-6 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <Wifi className="w-4 h-4 text-slate-500" />
                <span className="text-slate-700">Connection Status</span>
              </div>
              <span className="text-red-600 font-medium">Disconnected</span>
            </div>
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-slate-400 rounded"></div>
                <span className="text-slate-700">Streaming Service</span>
              </div>
              <span className="text-slate-500 font-medium">Offline</span>
            </div>
          </div>

          {/* Action Button */}
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2 mb-4">
            <RefreshCw className="w-5 h-5" />
            Retry Connection
          </button>

          {/* Help Text */}
          <p className="text-xs text-slate-500">
            If the problem persists, please contact support or try again later.
          </p>
        </div>
      </div>
    </div>
  );
}

export default StreamingUnavailable;
